/* ============================================================
   Product + Collection Page — Scoped JS
   Only runs on product and collection templates
   ============================================================ */
(function () {
  'use strict';

  var isProduct = document.querySelector('.product-section');
  var isCollection = document.querySelector('.collection-section');

  /* ---------- Product Gallery ---------- */
  if (isProduct) {
    var slider = document.querySelector('[data-product-slider]');
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    var prevBtn = document.querySelector('[data-product-prev]');
    var nextBtn = document.querySelector('[data-product-next]');
    var slides = slider ? slider.querySelectorAll('.product-media__slide') : [];

    function syncThumbs() {
      if (!slider) return;
      var idx = Math.round(slider.scrollLeft / slider.clientWidth);
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-selected', i === idx);
      });
      slides.forEach(function (s, i) {
        s.classList.toggle('is-selected', i === idx);
      });
    }

    if (slider) {
      slider.addEventListener('scroll', syncThumbs, { passive: true });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (slider) {
          slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (slider) slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (slider) slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
      });
    }

    /* ---------- Mobile Slider with Dots ---------- */
    var mobileSlider = document.querySelector('[data-mobile-slider]');
    var mobileTrack = document.querySelector('[data-mobile-track]');
    var mobileDotsContainer = document.querySelector('[data-mobile-dots]');

    if (mobileTrack && mobileDotsContainer) {
      var mobileSlides = mobileTrack.querySelectorAll('.product-media__slider-slide');
      var mobileDots = [];

      mobileSlides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-media__slider-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () {
          mobileTrack.scrollTo({ left: i * mobileTrack.clientWidth, behavior: 'smooth' });
        });
        mobileDotsContainer.appendChild(dot);
        mobileDots.push(dot);
      });

      mobileTrack.addEventListener('scroll', function () {
        var idx = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
        mobileDots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }, { passive: true });

      var mobilePrev = document.querySelector('[data-mobile-prev]');
      var mobileNext = document.querySelector('[data-mobile-next]');
      if (mobilePrev) {
        mobilePrev.addEventListener('click', function () {
          mobileTrack.scrollBy({ left: -mobileTrack.clientWidth, behavior: 'smooth' });
        });
      }
      if (mobileNext) {
        mobileNext.addEventListener('click', function () {
          mobileTrack.scrollBy({ left: mobileTrack.clientWidth, behavior: 'smooth' });
        });
      }
    }

    /* ---------- Variant Switching ---------- */
    var productJsonEl = document.querySelector('[data-product-json]');
    var productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    var optionInputs = document.querySelectorAll('[data-option-input]');
    var variantIdInput = document.querySelector('[data-variant-id]');
    var priceContainer = document.querySelector('[data-product-price]');
    var atcBtn = document.querySelector('[data-atc-button]');
    var atcText = document.querySelector('[data-atc-text]');
    var productForm = document.querySelector('[data-product-form]');

    function getSelectedOptions() {
      var opts = {};
      if (productData && productData.selected_options && productData.options) {
        productData.options.forEach(function (name, index) {
          opts[name] = productData.selected_options[index];
        });
      }
      optionInputs.forEach(function (input) {
        if (input.checked) {
          opts[input.getAttribute('data-option-name')] = input.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      if (!productData) return null;
      var optNames = productData.options;
      return productData.variants.find(function (v) {
        return v.options.every(function (val, i) {
          var optionName = optNames[i];
          var selectedValue = opts[optionName];
          if (selectedValue === undefined) {
            var matchingKey = Object.keys(opts).find(function (key) {
              var normalizedKey = key.toLowerCase().replace(/^colour$/, 'color');
              var normalizedName = optionName.toLowerCase().replace(/^colour$/, 'color');
              return normalizedKey === normalizedName;
            });
            selectedValue = matchingKey ? opts[matchingKey] : undefined;
          }
          return val === selectedValue;
        });
      });
    }

    function formatMoney(cents) {
      var format = '${{amount}}';
      if (window.theme && window.theme.moneyFormat) {
        format = window.theme.moneyFormat;
      }
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;

      // Update variant ID
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update price
      if (priceContainer) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="product-info__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        html += '<span class="product-info__price--current">' + formatMoney(variant.price) + '</span>';
        priceContainer.innerHTML = html;
      }

      // Update ATC button
      if (atcBtn) {
        // Pre Order products: always keep button disabled with "Pre Order" text
        if (productForm && productForm.getAttribute('data-pre-order') === 'true') {
          atcBtn.disabled = true;
          if (atcText) atcText.textContent = 'Pre Order';
        } else {
          atcBtn.disabled = !variant.available;
          if (atcText) {
            atcText.textContent = variant.available ? 'Add to cart' : 'Sold out';
          }
        }
      }

      // Update URL — keep clean product URL without ?variant= parameter
      var newUrl = window.location.pathname;
      history.replaceState(null, '', newUrl);

      // Update gallery image if variant has featured image
      if (variant.featured_image_id && slider) {
        var slideIdx = Array.prototype.findIndex.call(slides, function (s) {
          return s.getAttribute('data-media-id') === String(variant.featured_image_id);
        });
        if (slideIdx >= 0) {
          slider.scrollTo({ left: slideIdx * slider.clientWidth, behavior: 'smooth' });
        }
      }

      // Update option labels
      Object.keys(opts).forEach(function (name) {
        var handle = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        var labelSpan = document.querySelector('[data-option-value="' + handle + '"]');
        if (labelSpan) labelSpan.textContent = opts[name];
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateUI);
    });

    // Initialize
    updateUI();

    // Clean ?variant= from the browser URL on initial page load
    // (deep-link still works — server already selected the correct variant)
    if (window.location.search.indexOf('variant=') !== -1) {
      history.replaceState(null, '', window.location.pathname);
    }

    /* ---------- Quantity ---------- */
    var qtyInput = document.querySelector('[data-qty-input]');
    var qtyMinus = document.querySelector('[data-qty-minus]');
    var qtyPlus = document.querySelector('[data-qty-plus]');

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        if (qtyInput) {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        }
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        if (qtyInput) {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
        }
      });
    }

    /* ---------- ATC Form AJAX ---------- */
    if (productForm) {
      // Coming Soon guard — block form submission entirely for coming-soon products
      if (productForm.getAttribute('data-coming-soon') === 'true') {
        productForm.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }, true);
      } else if (productForm.getAttribute('data-pre-order') === 'true') {
        // Pre Order guard — block form submission entirely for pre-order products
        productForm.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }, true);
      } else {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn) {
          atcBtn.disabled = true;
          if (atcText) atcText.textContent = 'Adding...';
        }
        // Use the global WBCCart API (defined in theme.js)
        if (window.WBCCart && window.WBCCart.add) {
          window.WBCCart.add(
            new FormData(productForm),
            function () {
              if (atcText) atcText.textContent = 'Added!';
              setTimeout(function () {
                if (atcText) atcText.textContent = 'Add to cart';
                if (atcBtn) atcBtn.disabled = false;
              }, 1500);
            },
            function () {
              if (atcText) atcText.textContent = 'Error';
              setTimeout(function () {
                if (atcText) atcText.textContent = 'Add to cart';
                if (atcBtn) atcBtn.disabled = false;
              }, 2000);
            }
          );
        } else {
          // Fallback: direct fetch if WBCCart not available
          fetch(productForm.action + '.js', {
            method: 'POST',
            body: new FormData(productForm),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              if (atcText) atcText.textContent = 'Added!';
              setTimeout(function () {
                if (atcText) atcText.textContent = 'Add to cart';
                if (atcBtn) atcBtn.disabled = false;
              }, 1500);
            })
            .catch(function () {
              if (atcText) atcText.textContent = 'Error';
              setTimeout(function () {
                if (atcText) atcText.textContent = 'Add to cart';
                if (atcBtn) atcBtn.disabled = false;
              }, 2000);
            });
        }
      });
      }
    }
  }

  /* ---------- Collection Card Image Slider (mobile touch) ---------- */
  function initCardSliders() {
    var ccardSliders = document.querySelectorAll('[data-ccard-slider]');
    ccardSliders.forEach(function (slider) {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = 'true';
      var link = slider.parentElement.querySelector('.ccard__media-link');
      var linkUrl = link ? link.getAttribute('href') : '';
      var startX = 0, startY = 0, startTime = 0, hasMoved = false;

      slider.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTime = Date.now();
        hasMoved = false;
      }, { passive: true });

      slider.addEventListener('touchmove', function (e) {
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > 10 || dy > 10) hasMoved = true;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        var elapsed = Date.now() - startTime;
        if (!hasMoved && elapsed < 300 && linkUrl) {
          window.location.href = linkUrl;
        }
      }, { passive: true });

      slider.addEventListener('click', function (e) {
        if (linkUrl && !hasMoved) {
          window.location.href = linkUrl;
        }
      });
    });
  }
  if (isCollection) initCardSliders();

  /* ---------- Collection Card Swatches ---------- */
  function initCardSwatches() {
    var cardSwatches = document.querySelectorAll('[data-swatch-value]');
    cardSwatches.forEach(function (swatch) {
      if (swatch.dataset.swatchInit) return;
      swatch.dataset.swatchInit = 'true';
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var colorsContainer = swatch.closest('[data-card-colors]');
        if (!colorsContainer) return;

        colorsContainer.querySelectorAll('.ccard__swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');

        var selectedLabel = colorsContainer.querySelector('[data-card-color-selected]');
        if (selectedLabel) {
          selectedLabel.textContent = swatch.getAttribute('title') || swatch.getAttribute('data-swatch-value');
        }

        var newImg = swatch.getAttribute('data-swatch-image');
        var card = colorsContainer.closest('.ccard');
        if (newImg && card) {
          var mainImg = card.querySelector('.ccard__image--main');
          if (mainImg) mainImg.src = newImg;
        }

        var newUrl = swatch.getAttribute('data-swatch-url');
        if (newUrl && card) {
          var link = card.querySelector('.ccard__media-link');
          var titleLink = card.querySelector('.ccard__title a');
          if (link) link.setAttribute('href', newUrl);
          if (titleLink) titleLink.setAttribute('href', newUrl);
        }
      });
    });
  }
  if (isCollection) initCardSwatches();

    /* ---------- Filter: Desktop Horizontal Filter Bar ---------- */
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var filterDropdowns = document.querySelectorAll('[data-filter-dropdown]');
    var filterDropdownTriggers = document.querySelectorAll('[data-filter-dropdown-trigger]');
    var filterFormDesktop = document.querySelector('[data-filter-form-desktop]');
    var filterClearDesktop = document.querySelector('[data-filter-clear-desktop]');
    var filterApplyBtnsDesktop = document.querySelectorAll('[data-filter-apply-btn-desktop]');
    var filterPriceApplyDesktop = document.querySelector('[data-filter-apply-desktop]');

    /* Mobile drawer functions (declared early so desktop toggle can call openFilter) */
    var filterDrawer = document.querySelector('[data-filter-drawer]');
    var filterClose = document.querySelector('[data-filter-close]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    function openFilter() {
      if (filterDrawer) filterDrawer.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function closeFilter() {
      if (filterDrawer) filterDrawer.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    /* Desktop: individual dropdown toggle — only one open at a time */
    function closeAllDesktopDropdowns() {
      filterDropdowns.forEach(function (dd) { dd.classList.remove('is-open'); });
      document.querySelectorAll('[data-sort-dropdown]').forEach(function (sd) { sd.classList.remove('is-open'); });
    }

    filterDropdownTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parent = trigger.closest('[data-filter-dropdown]');
        if (!parent) return;
        var wasOpen = parent.classList.contains('is-open');
        closeAllDesktopDropdowns();
        if (!wasOpen) parent.classList.add('is-open');
      });
    });

    /* Close dropdown on outside click */
    document.addEventListener('click', function (e) {
      filterDropdowns.forEach(function (dd) {
        if (dd.classList.contains('is-open') && !dd.contains(e.target)) {
          dd.classList.remove('is-open');
        }
      });
    });

    /* Mobile: filter toggle opens drawer */
    if (filterToggle) {
      filterToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (window.innerWidth < 768) {
          openFilter();
        }
      });
    }

    /* ---------- Mobile Filter Accordion (expand/collapse, +/− indicator) ---------- */
    var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
    accordionToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var group = btn.closest('[data-accordion-group]');
        if (!group) return;
        var content = group.querySelector('[data-accordion-content]');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        if (content) {
          content.hidden = expanded;
        }
        group.classList.toggle('is-open', !expanded);
      });
    });

    /* ---------- AJAX Filter: fetch and update grid without page reload ---------- */
    var collectionGrid = document.querySelector('[data-collection-grid]');
    var collectionCount = document.querySelector('.collection-count');
    var collectionPagination = document.querySelector('.collection-pagination');

    // Request tracking — cancel outdated fetches to prevent race conditions
    var filterRequestId = 0;
    var currentFetchController = null;

    // Collection sort state — tracks if a collection sort is active so
    // filter updates can re-apply it after replacing the grid
    var activeCollectionSort = null; // { handle: 'xxx', name: 'XXX' }

    /* ---------- Client-side Color Filter (works even without Shopify's
       Search & Discovery filter app enabled). Reads any URL param named
       filter.v.option.<ColorOptionName> and shows only product cards
       (.ccard) whose data-product-colors list contains a selected value. ---------- */
    function applyClientColorFilter() {
      if (!collectionGrid) return;
      var cards = collectionGrid.querySelectorAll('.ccard');
      if (!cards.length) return;

      var params = new URLSearchParams(window.location.search);
      var selectedColors = [];
      params.forEach(function (val, key) {
        if (/^filter\.v\.option\./i.test(key) && /colou?r/i.test(key)) {
          selectedColors.push(val.toLowerCase().trim());
        }
      });

      var visibleCount = 0;
      if (selectedColors.length === 0) {
        // No color filter active — show all cards
        cards.forEach(function (card) {
          card.style.display = '';
          visibleCount++;
        });
      } else {
        cards.forEach(function (card) {
          var productColorsAttr = card.getAttribute('data-product-colors') || '';
          var productColors = productColorsAttr.toLowerCase().split('|').map(function (c) { return c.trim(); }).filter(Boolean);
          var matches = selectedColors.some(function (sel) { return productColors.indexOf(sel) !== -1; });
          if (matches) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });
      }

      // Show/hide "no products" message
      var emptyMsg = collectionGrid.querySelector('.collection-grid__client-empty');
      if (visibleCount === 0 && selectedColors.length > 0) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('p');
          emptyMsg.className = 'collection-grid__empty collection-grid__client-empty';
          emptyMsg.style.gridColumn = '1 / -1';
          emptyMsg.textContent = 'No products found for the selected color.';
          collectionGrid.appendChild(emptyMsg);
        }
        emptyMsg.style.display = '';
      } else if (emptyMsg) {
        emptyMsg.style.display = 'none';
      }
    }
    // Run on initial page load (handles direct/shared links with color filter in URL)
    applyClientColorFilter();

    /* ---------- Selected Filter Tags (removable, above product grid) ---------- */
    var activeFiltersContainer = document.querySelector('[data-active-filters]');

    function getFilterLabel(key) {
      // Map URL param keys to human-readable labels
      var keyLower = key.toLowerCase();
      if (keyLower.indexOf('availability') !== -1) return 'AVAILABILITY';
      if (keyLower.indexOf('colour') !== -1 || keyLower.indexOf('color') !== -1) return 'COLOUR';
      if (keyLower.indexOf('length') !== -1 || keyLower.indexOf('inch') !== -1) return 'LENGTH';
      if (keyLower.indexOf('price.gte') !== -1) return 'PRICE MIN';
      if (keyLower.indexOf('price.lte') !== -1) return 'PRICE MAX';
      if (keyLower.indexOf('option.') !== -1) {
        var parts = key.split('option.');
        if (parts[1]) return parts[1].replace(/_/g, ' ').toUpperCase();
      }
      return key.replace(/^filter\.v\./, '').replace(/\./g, ' ').toUpperCase();
    }

    function renderActiveFilters() {
      if (!activeFiltersContainer) return;
      activeFiltersContainer.innerHTML = '';
      var params = new URLSearchParams(window.location.search);
      var hasFilters = false;
      params.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) {
          hasFilters = true;
          var label = getFilterLabel(key);
          var tag = document.createElement('span');
          tag.className = 'collection-active-filters__tag';
          var labelEl = document.createElement('span');
          labelEl.className = 'collection-active-filters__tag-label';
          labelEl.textContent = label + ': ' + val;
          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'collection-active-filters__tag-remove';
          removeBtn.setAttribute('aria-label', 'Remove filter ' + label + ': ' + val);
          removeBtn.innerHTML = '&times;';
          (function (k, v) {
            removeBtn.addEventListener('click', function () {
              removeFilterTag(k, v);
            });
          })(key, val);
          tag.appendChild(labelEl);
          tag.appendChild(removeBtn);
          activeFiltersContainer.appendChild(tag);
        }
      });
    }

    function removeFilterTag(key, value) {
      var url = new URL(window.location.href);
      var params = url.searchParams;
      // Remove the specific param matching key+value
      var allVals = params.getAll(key);
      params.delete(key);
      allVals.forEach(function (v) {
        if (v !== value) params.append(key, v);
      });
      url.search = params.toString();
      // Update checkbox state to match
      if (filterFormDesktop) {
        var cb = filterFormDesktop.querySelector('[name="' + key + '"][value="' + value.replace(/"/g, '\\"') + '"]');
        if (cb) cb.checked = false;
      }
      fetchFilteredProducts(url.toString());
    }

    // Render on initial load
    renderActiveFilters();

    function updateGridFromHTML(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-collection-grid]');
      var newCount = doc.querySelector('.collection-count');
      var newPagination = doc.querySelector('.collection-pagination');
      if (newGrid && collectionGrid) collectionGrid.innerHTML = newGrid.innerHTML;
      if (newCount && collectionCount) collectionCount.innerHTML = newCount.innerHTML;
      if (newPagination) {
        if (collectionPagination) {
          collectionPagination.innerHTML = newPagination.innerHTML;
        } else {
          if (collectionGrid && collectionGrid.parentNode) {
            var pagNav = document.createElement('nav');
            pagNav.className = 'collection-pagination';
            pagNav.innerHTML = newPagination.innerHTML;
            collectionGrid.parentNode.insertBefore(pagNav, collectionGrid.nextSibling);
            collectionPagination = pagNav;
          }
        }
      } else if (collectionPagination) {
        collectionPagination.innerHTML = '';
      }
      // Sync filter checkbox states from the fetched page
      syncFilterStates(doc);
      // Re-init card sliders for new content
      initCardSliders();
      // Re-init swatches
      initCardSwatches();
      // Re-apply client-side color filter (Shopify may not filter by color
      // server-side if its native variant filter isn't configured)
      applyClientColorFilter();
      // Re-render selected filter tags
      renderActiveFilters();
      // Re-apply collection sort if one is active (filters may have changed the product set)
      if (activeCollectionSort) {
        applyCollectionSort(activeCollectionSort.handle, activeCollectionSort.name);
      }
    }

    function syncFilterStates(doc) {
      // Sync desktop filter checkboxes — skip color checkboxes (they are restored from URL below)
      if (filterFormDesktop) {
        var newDesktopForm = doc.querySelector('[data-filter-form-desktop]');
        if (newDesktopForm) {
          var newDesktopChecks = newDesktopForm.querySelectorAll('[data-filter-checkbox-desktop]');
          newDesktopChecks.forEach(function (newCb) {
            if (newCb.hasAttribute('data-color-checkbox-desktop')) return; // skip color, restored from URL
            var existing = filterFormDesktop.querySelector('[name="' + newCb.getAttribute('name') + '"][value="' + newCb.getAttribute('value') + '"]');
            if (existing) existing.checked = newCb.checked;
          });
        }
      }
      // Sync mobile filter checkboxes — skip color checkboxes
      if (filterForm) {
        var newMobileForm = doc.querySelector('[data-filter-form]');
        if (newMobileForm) {
          var newMobileChecks = newMobileForm.querySelectorAll('[data-filter-checkbox]');
          newMobileChecks.forEach(function (newCb) {
            if (newCb.hasAttribute('data-color-checkbox')) return; // skip color, restored from URL
            var existing = filterForm.querySelector('[name="' + newCb.getAttribute('name') + '"][value="' + newCb.getAttribute('value') + '"]');
            if (existing) existing.checked = newCb.checked;
          });
        }
      }
      // Restore color checkbox states from URL (both desktop + mobile)
      restoreColorCheckboxStates();
    }

    /* Restore color checkbox checked state from URL params — ensures multiple
       colors stay checked after AJAX filter updates. */
    function restoreColorCheckboxStates() {
      var urlParams = new URLSearchParams(window.location.search);
      // Uncheck all color checkboxes first
      var allColorDesktop = filterFormDesktop ? filterFormDesktop.querySelectorAll('[data-color-checkbox-desktop]') : [];
      var allColorMobile = filterForm ? filterForm.querySelectorAll('[data-color-checkbox]') : [];
      allColorDesktop.forEach(function (cb) { cb.checked = false; });
      allColorMobile.forEach(function (cb) { cb.checked = false; });
      // Check the ones that are in the URL
      urlParams.forEach(function (val, key) {
        if (/colou?r/i.test(key)) {
          allColorDesktop.forEach(function (cb) {
            if (cb.getAttribute('name') === key && cb.value === val) cb.checked = true;
          });
          allColorMobile.forEach(function (cb) {
            if (cb.getAttribute('name') === key && cb.value === val) cb.checked = true;
          });
        }
      });
    }

    function fetchFilteredProducts(filterUrl) {
      // Increment request ID and abort previous fetch if still in-flight
      var myRequestId = ++filterRequestId;
      if (currentFetchController) {
        try { currentFetchController.abort(); } catch (e) {}
      }
      currentFetchController = (typeof AbortController !== 'undefined') ? new AbortController() : null;

      // Show loading state
      if (collectionGrid) collectionGrid.style.opacity = '0.5';
      fetch(filterUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: currentFetchController ? currentFetchController.signal : undefined
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Ignore if a newer request was started
          if (myRequestId !== filterRequestId) return;
          // Update URL BEFORE re-rendering the grid so that
          // applyClientColorFilter() (called inside updateGridFromHTML)
          // reads the NEW filter params, not the stale previous URL.
          window.history.pushState({ path: filterUrl }, '', filterUrl);
          updateGridFromHTML(html);
          if (collectionGrid) collectionGrid.style.opacity = '1';
        })
        .catch(function (err) {
          if (myRequestId !== filterRequestId) return; // superseded, ignore
          // AbortError is expected when a newer request cancels this one
          if (err && err.name === 'AbortError') return;
          // Fallback to full page load
          window.location.href = filterUrl;
        });
    }

    /* ---------- Filter: Desktop Panel Apply/Clear ---------- */
    function applyFiltersDesktop() {
      if (!filterFormDesktop) return;
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var sortVal = params.get('sort_by');
      var keysToRemove = [];
      params.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) keysToRemove.push(key);
      });
      keysToRemove.forEach(function (key) { params.delete(key); });

      var checkboxes = filterFormDesktop.querySelectorAll('[data-filter-checkbox-desktop]:checked');
      var groupedParams = {};
      checkboxes.forEach(function (cb) {
        var name = cb.getAttribute('name');
        if (!groupedParams[name]) groupedParams[name] = [];
        groupedParams[name].push(cb.value);
      });
      Object.keys(groupedParams).forEach(function (name) {
        groupedParams[name].forEach(function (val) {
          params.append(name, val);
        });
      });

      var priceMin = filterFormDesktop.querySelector('[data-filter-price-min-desktop]');
      var priceMax = filterFormDesktop.querySelector('[data-filter-price-max-desktop]');
      if (priceMin && priceMin.value) params.set('filter.v.price.gte', priceMin.value);
      if (priceMax && priceMax.value) params.set('filter.v.price.lte', priceMax.value);

      if (sortVal) params.set('sort_by', sortVal);
      url.search = params.toString();
      // Always fetch via AJAX. Any Shopify-native filters (availability, price,
      // length, etc.) are applied server-side; the Color filter is additionally
      // enforced client-side in applyClientColorFilter() since Shopify only
      // honors filter.v.option.Color when its native variant filter is enabled.
      fetchFilteredProducts(url.toString());
    }

    if (filterApplyBtnsDesktop) {
      filterApplyBtnsDesktop.forEach(function (btn) {
        btn.addEventListener('click', function () { applyFiltersDesktop(); closeAllDesktopDropdowns(); });
      });
    }
    if (filterPriceApplyDesktop) filterPriceApplyDesktop.addEventListener('click', function () { applyFiltersDesktop(); closeAllDesktopDropdowns(); });

    /* Color filter: apply immediately on checkbox change (no Apply button) */
    var colorCheckboxesDesktop = filterFormDesktop ? filterFormDesktop.querySelectorAll('[data-color-checkbox-desktop]') : [];
    colorCheckboxesDesktop.forEach(function (cb) {
      cb.addEventListener('change', function () {
        applyFiltersDesktop();
      });
    });

    if (filterClearDesktop) {
      filterClearDesktop.addEventListener('click', function () {
        var url = new URL(window.location.href);
        var params = url.searchParams;
        var sortVal = params.get('sort_by');
        var keysToRemove = [];
        params.forEach(function (val, key) {
          if (key.indexOf('filter.') === 0) keysToRemove.push(key);
        });
        keysToRemove.forEach(function (key) { params.delete(key); });
        if (sortVal) params.set('sort_by', sortVal);
        url.search = params.toString();
        fetchFilteredProducts(url.toString());
      });
    }

    // Restore desktop filter state from URL
    if (filterFormDesktop) {
      var urlParamsD = new URLSearchParams(window.location.search);
      urlParamsD.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) {
          var input = filterFormDesktop.querySelector('[name="' + key + '"][value="' + val.replace(/"/g, '\\"') + '"]');
          if (input) input.checked = true;
          if (key === 'filter.v.price.gte') {
            var minInput = filterFormDesktop.querySelector('[data-filter-price-min-desktop]');
            if (minInput) minInput.value = val;
          }
          if (key === 'filter.v.price.lte') {
            var maxInput = filterFormDesktop.querySelector('[data-filter-price-max-desktop]');
            if (maxInput) maxInput.value = val;
          }
        }
      });
    }

    /* ---------- Filter: Mobile Drawer ---------- */
    var filterForm = document.querySelector('[data-filter-form]');
    var filterClearBtn = document.querySelector('[data-filter-clear]');
    var filterApplyBtn = document.querySelector('[data-filter-apply-btn]');
    var filterPriceApply = document.querySelector('[data-filter-apply]');

    if (filterClose) filterClose.addEventListener('click', closeFilter);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);

    /* ---------- Filter Form Submission ---------- */
    function applyFilters() {
      if (!filterForm) return;
      var url = new URL(window.location.href);
      var params = url.searchParams;

      // Remove existing filter params (keep sort_by)
      var sortVal = params.get('sort_by');
      var keysToRemove = [];
      params.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) keysToRemove.push(key);
      });
      keysToRemove.forEach(function (key) { params.delete(key); });

      // Collect checked checkboxes
      var checkboxes = filterForm.querySelectorAll('[data-filter-checkbox]:checked');
      var groupedParams = {};
      checkboxes.forEach(function (cb) {
        var name = cb.getAttribute('name');
        if (!groupedParams[name]) groupedParams[name] = [];
        groupedParams[name].push(cb.value);
      });
      Object.keys(groupedParams).forEach(function (name) {
        groupedParams[name].forEach(function (val) {
          params.append(name, val);
        });
      });

      // Price range
      var priceMin = filterForm.querySelector('[data-filter-price-min]');
      var priceMax = filterForm.querySelector('[data-filter-price-max]');
      if (priceMin && priceMin.value) {
        params.set('filter.v.price.gte', priceMin.value);
      }
      if (priceMax && priceMax.value) {
        params.set('filter.v.price.lte', priceMax.value);
      }

      // Preserve sort
      if (sortVal) params.set('sort_by', sortVal);

      url.search = params.toString();
      // Always fetch via AJAX. Any Shopify-native filters (availability, price,
      // length, etc.) are applied server-side; the Color filter is additionally
      // enforced client-side in applyClientColorFilter() since Shopify only
      // honors filter.v.option.Color when its native variant filter is enabled.
      fetchFilteredProducts(url.toString());
    }

    if (filterApplyBtn) filterApplyBtn.addEventListener('click', function () { applyFilters(); closeFilter(); });
    if (filterPriceApply) filterPriceApply.addEventListener('click', applyFilters);

    // No auto-apply — user must tap Apply button
    var filterCheckboxes = filterForm ? filterForm.querySelectorAll('[data-filter-checkbox]') : [];
    filterCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        // Visual feedback only, no auto-apply
      });
    });

    // Clear all filters
    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', function () {
        var url = new URL(window.location.href);
        var params = url.searchParams;
        var sortVal = params.get('sort_by');
        var keysToRemove = [];
        params.forEach(function (val, key) {
          if (key.indexOf('filter.') === 0) keysToRemove.push(key);
        });
        keysToRemove.forEach(function (key) { params.delete(key); });
        if (sortVal) params.set('sort_by', sortVal);
        url.search = params.toString();
        fetchFilteredProducts(url.toString());
      });
    }

    // Restore filter state from URL
    if (filterForm) {
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach(function (val, key) {
        if (key.indexOf('filter.') === 0) {
          var input = filterForm.querySelector('[name="' + key + '"][value="' + val.replace(/"/g, '\\"') + '"]');
          if (input) input.checked = true;
          if (key === 'filter.v.price.gte') {
            var minInput = filterForm.querySelector('[data-filter-price-min]');
            if (minInput) minInput.value = val;
          }
          if (key === 'filter.v.price.lte') {
            var maxInput = filterForm.querySelector('[data-filter-price-max]');
            if (maxInput) maxInput.value = val;
          }
        }
      });
    }

    /* ---------- Sort: Desktop Dropdown (inside filter bar) ---------- */
    // There are two [data-sort-dropdown] elements: one in the (hidden) toolbar
    // and one in the visible filter bar. Attach handlers to ALL of them so the
    // visible one actually works.
    var sortDropdowns = document.querySelectorAll('[data-sort-dropdown]');
    var sortTriggers = document.querySelectorAll('[data-sort-trigger]');
    var sortOptions = document.querySelectorAll('[data-sort-menu] .collection-filterbar__sort-option');
    var isAllProductsPage = document.querySelector('[data-all-products-page]') !== null;

    /* ---------- Collection Sort (All Products page only) ---------- */
    // Reorders product cards client-side: products in the selected collection
    // move to the top, all others remain below. No page navigation.
    // All products are already in the DOM (paginate by 250), so we only
    // need 1 small JSON fetch to get the selected collection's handles,
    // then instantly reorder the existing DOM cards.
    // Caches collection handles to avoid re-fetching on filter updates.
    var collectionSortRequestId = 0;
    var collectionHandleCache = {}; // { handle: [productHandle1, productHandle2, ...] }

    function applyCollectionSort(collectionHandle, collectionName) {
      if (!collectionGrid) return;
      // Track active collection sort so filter updates can re-apply it
      activeCollectionSort = { handle: collectionHandle, name: collectionName };
      var myRequestId = ++collectionSortRequestId;
      collectionGrid.style.opacity = '0.5';

      function doReorder(selectedOrder) {
        // Ignore if a newer sort request was started
        if (myRequestId !== collectionSortRequestId) return;

        // Build map of ALL cards currently in the DOM
        var domCards = {};
        var domHandles = [];
        var domCardList = collectionGrid.querySelectorAll('.ccard');
        domCardList.forEach(function (card) {
          var h = card.getAttribute('data-ccard-product-handle');
          if (h) {
            if (!domCards[h]) {
              domCards[h] = card;
              domHandles.push(h);
            } else {
              // Duplicate handle — still keep the card by using a fallback key
              var fallbackKey = h + '__dup_' + Math.random().toString(36).substr(2, 5);
              domCards[fallbackKey] = card;
              domHandles.push(fallbackKey);
            }
          }
        });

        // Build set of selected collection handles for fast lookup
        var selectedSet = {};
        selectedOrder.forEach(function (h) { selectedSet[h] = true; });

        // Build reordered list:
        // 1. Selected collection products first (in collection order)
        // 2. Remaining all-products products underneath
        var reorderedCards = [];
        var usedCards = []; // track actual DOM nodes used to avoid duplicates
        var usedNodeSet = new Set();

        // Selected collection products first (preserve collection order)
        selectedOrder.forEach(function (h) {
          if (domCards[h] && !usedNodeSet.has(domCards[h])) {
            reorderedCards.push(domCards[h]);
            usedNodeSet.add(domCards[h]);
          }
        });

        // Remaining all-products products (ALL of them, never drop any)
        domCardList.forEach(function (card) {
          if (!usedNodeSet.has(card)) {
            reorderedCards.push(card);
            usedNodeSet.add(card);
          }
        });

        // Safety check: never lose cards
        if (reorderedCards.length < domCardList.length) {
          // Something went wrong — don't touch the grid
          collectionGrid.style.opacity = '1';
          return;
        }

        // Reorder DOM nodes using insertBefore (preserves event listeners)
        var firstChild = collectionGrid.firstChild;
        reorderedCards.forEach(function (card) {
          collectionGrid.insertBefore(card, firstChild);
        });

        // Remove any leftover nodes that aren't in reorderedCards (e.g., empty messages)
        var allNodes = Array.prototype.slice.call(collectionGrid.childNodes);
        var reorderSet = new Set(reorderedCards);
        allNodes.forEach(function (node) {
          if (node.nodeType === 1 && !reorderSet.has(node) && node.classList && !node.classList.contains('collection-grid__empty') && !node.classList.contains('collection-grid__client-empty')) {
            // Only remove non-card elements that aren't empty messages
            if (node.classList.contains('ccard')) {
              collectionGrid.removeChild(node);
            }
          }
        });

        // Hide pagination (all products shown on one page)
        var pagination = document.querySelector('.collection-pagination');
        if (pagination) pagination.style.display = 'none';

        // Update product count text
        var countEl = document.querySelector('.collection-count');
        if (countEl) {
          countEl.textContent = 'Showing 1 - ' + reorderedCards.length + ' of ' + reorderedCards.length + ' total';
        }

        collectionGrid.style.opacity = '1';

        // Update trigger labels
        sortTriggers.forEach(function (tr) {
          var span = tr.querySelector('span');
          if (span) span.textContent = collectionName;
        });
        var mobileTriggerSpan = document.querySelector('[data-sort-mobile-trigger] span');
        if (mobileTriggerSpan) mobileTriggerSpan.textContent = collectionName;
      }

      // Use cached handles if available, otherwise fetch
      if (collectionHandleCache[collectionHandle]) {
        doReorder(collectionHandleCache[collectionHandle]);
      } else {
        fetch('/collections/' + collectionHandle + '/products.json?limit=250')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (myRequestId !== collectionSortRequestId) return; // superseded
            var selectedOrder = [];
            if (data && data.products) {
              data.products.forEach(function (p) {
                selectedOrder.push(p.handle);
              });
            }
            // Cache for future re-applies (after filter updates)
            collectionHandleCache[collectionHandle] = selectedOrder;
            doReorder(selectedOrder);
          })
          .catch(function () {
            if (myRequestId !== collectionSortRequestId) return;
            collectionGrid.style.opacity = '1';
          });
      }
    }

    function resetSortLabel() {
      sortTriggers.forEach(function (tr) {
        var span = tr.querySelector('span');
        if (span) span.textContent = 'Sort by';
      });
      var mobileTriggerSpan = document.querySelector('[data-sort-mobile-trigger] span');
      if (mobileTriggerSpan) mobileTriggerSpan.textContent = 'Sort Order';
    }

    function applySort(value) {
      // Collection-based sort (All Products page only)
      if (isAllProductsPage && value && value.indexOf('collection-') === 0) {
        var collHandle = value.substring('collection-'.length);
        var collOpt = document.querySelector('[data-sort-collection="' + collHandle + '"]');
        var collName = collOpt ? collOpt.textContent.trim() : 'Sort by';
        // Update active states
        sortOptions.forEach(function (o) { o.classList.remove('is-active'); });
        sortDrawerOptions.forEach(function (o) { o.classList.remove('is-active'); });
        if (collOpt) collOpt.classList.add('is-active');
        var collOptMobile = document.querySelector('[data-sort-drawer] [data-sort-collection="' + collHandle + '"]');
        if (collOptMobile) collOptMobile.classList.add('is-active');
        applyCollectionSort(collHandle, collName);
        return;
      }
      // Standard Shopify sort
      resetSortLabel();
      // Clear collection sort state
      activeCollectionSort = null;
      // Restore pagination visibility (was hidden during collection sort)
      var paginationEl = document.querySelector('.collection-pagination');
      if (paginationEl) paginationEl.style.display = '';
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      fetchFilteredProducts(url.toString());
    }

    // Highlight current sort
    var currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    sortOptions.forEach(function (opt) {
      if (opt.getAttribute('data-sort-value') === currentSort) {
        opt.classList.add('is-active');
      }
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        applySort(opt.getAttribute('data-sort-value'));
      });
    });

    sortTriggers.forEach(function (sortTrigger) {
      var sortDropdown = sortTrigger.closest('[data-sort-dropdown]');
      if (!sortTrigger || !sortDropdown) return;
      sortTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Close any open filter dropdowns
        closeAllDesktopDropdowns();
        // Close all other sort dropdowns
        sortDropdowns.forEach(function (sd) {
          if (sd !== sortDropdown) sd.classList.remove('is-open');
        });
        sortDropdown.classList.toggle('is-open');
      });
    });

    // Close sort on outside click
    document.addEventListener('click', function (e) {
      sortDropdowns.forEach(function (sortDropdown) {
        if (sortDropdown.classList.contains('is-open') && !sortDropdown.contains(e.target)) {
          sortDropdown.classList.remove('is-open');
        }
      });
    });

    /* ---------- Sort: Mobile Drawer ---------- */
    var sortMobileTrigger = document.querySelector('[data-sort-mobile-trigger]');
    var sortDrawer = document.querySelector('[data-sort-drawer]');
    var sortClose = document.querySelector('[data-sort-close]');
    var sortOverlay = document.querySelector('[data-sort-overlay]');
    var sortDrawerOptions = document.querySelectorAll('[data-sort-drawer] .collection-sort-drawer__option');

    function openSortDrawer() {
      if (sortDrawer) sortDrawer.classList.add('is-open');
      if (sortOverlay) sortOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function closeSortDrawer() {
      if (sortDrawer) sortDrawer.classList.remove('is-open');
      if (sortOverlay) sortOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
    if (sortMobileTrigger) sortMobileTrigger.addEventListener('click', openSortDrawer);
    if (sortClose) sortClose.addEventListener('click', closeSortDrawer);
    if (sortOverlay) sortOverlay.addEventListener('click', closeSortDrawer);

    sortDrawerOptions.forEach(function (opt) {
      if (opt.getAttribute('data-sort-value') === currentSort) {
        opt.classList.add('is-active');
      }
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        applySort(opt.getAttribute('data-sort-value'));
        closeSortDrawer();
      });
    });

    // Handle browser back/forward — reload grid via AJAX
    window.addEventListener('popstate', function () {
      // Clear collection sort state on back/forward since URL changed
      activeCollectionSort = null;
      resetSortLabel();
      fetchFilteredProducts(window.location.href);
    });

  /* ---------- Wishlist (visual only) ---------- */
  var wishlistBtns = document.querySelectorAll('[data-wishlist]');
  wishlistBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
      var svg = btn.querySelector('svg');
      if (svg) {
        if (btn.classList.contains('is-active')) {
          svg.setAttribute('fill', 'currentColor');
          svg.setAttribute('stroke', 'currentColor');
        } else {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
        }
      }
    });
  });
})();
